import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import AsyncCreatableSelect from "react-select/async-creatable";

import { useRequest } from "@components/AppHook";
import { is_dict } from "@components/Utils";

export function WrapperSelect({ value, choices, readOnly, placeholder, disabled, clearable = true, ...props }) {
    // https://react-select.com

    // После модификации обязательно проверять
    // Финотчетность - Отчет по рекламе - Настройки - Найти несколько отчетов
    // Создание игры
    const { t } = useTranslation();

    let options = choices;
    if (is_dict(choices)) {
        options = Object.keys(choices).map((k) => {
            return { value: k, label: choices[k] };
        });
    }

    const val = value === null || value === undefined ? "" : value;
    const selected = options?.filter((o) => val !== undefined && val !== null && val.toString() === o.value.toString());
    return (
        <Select
            {...props}
            options={options}
            placeholder={placeholder || t("Выберите...")}
            isClearable={clearable}
            isDisabled={disabled}
            menuIsOpen={readOnly || disabled ? false : undefined}
            {...(!props.defaultValue && { value: selected })}
        />
    );
}

export function WrapperSuggestedSelect({
    name,
    value,
    choices,
    onChange,
    placeholder,
    disabled,
    readOnly,
    creatable,
    styles,
    handleOptionsLoading,
    suggestUrl,
    defaultOptions,
    isMulti = false,
    ...props
}) {
    // https://react-select.com
    // После модификации обязательно проверять
    // Основные свойства: Юридическая информация - Издатель
    // Администрирование: Основное - Метки
    // Модерация: Коммьюнити

    const { t } = useTranslation();
    const { api_get } = useRequest();

    const _val = value === null || value === undefined ? "" : value;
    const [selected, setSelected] = useState(
        value && Array.isArray(value) ? value.map((item) => ({ value: item, label: item })) : isMulti ? [] : ""
    );

    useEffect(() => {
        const selectedChoices = choices?.filter((o) => {
            if (isMulti) {
                const vals = Array.isArray(value) ? value : [value];
                return vals.some((v) => o.value.toString() === v.toString());
            }
            return _val.toString() === o.value.toString();
        });
        setSelected(selectedChoices);
    }, []);

    let loadOptions = handleOptionsLoading;
    if (!handleOptionsLoading) {
        loadOptions = (inp, callback) => {
            if (inp.length > 1) {
                const sgurl = `${suggestUrl}${suggestUrl.includes("?") ? "&suggest_query=" : "?suggest_query="}${inp}`;
                api_get(null, sgurl, {
                    then: (resp) => {
                        const options = resp.results.map((o) => ({ value: o.id, label: o.text }));
                        callback(options);
                    },
                });
            }
        };
    }

    const params = {
        ...props,
        styles,
        placeholder: placeholder || t("Введите минимум 2 символа для поиска..."),
        loadOptions: (inp, callback) => loadOptions(inp, callback),
        defaultOptions,
        isDisabled: disabled,
        isClearable: true,
        menuIsOpen: readOnly || disabled ? false : undefined,
        name,
        isMulti,
        value: selected,
        onChange: (data) => {
            setSelected(data);
            const selectedValues = isMulti ? data.map((o) => o.value) : data || "";
            onChange(selectedValues);
        },
    };

    return creatable ? <AsyncCreatableSelect {...params} createOptionPosition="first" /> : <AsyncSelect {...params} />;
}

export function WrapperMultipleSelect({
    name,
    value,
    choices,
    onChange,
    placeholder,
    disabled,
    readOnly,
    styles,
    hiddenChoices,
    ...props
}) {
    // https://react-select.com

    // После модификации обязательно проверять Основные свойства: поле жанр, теги
    const { t } = useTranslation();
    const [selected, setSelected] = useState([]);

    if (value === null || value === undefined) {
        value = "";
    }

    const hid_choices = hiddenChoices ? hiddenChoices.map((e) => e.toString()) : [];
    const options = choices.filter((ch) => !hid_choices.includes(ch.value.toString()));

    useEffect(() => {
        const res = [];
        const vals = Array.isArray(value) ? value : [value];
        vals.forEach((v) => {
            choices.forEach((o) => {
                if (o.value.toString() === v.toString() && !hid_choices.includes(v.toString())) {
                    res.push(o);
                }
            });
        });
        setSelected(res);
    }, [value]);
    return (
        <Select
            {...props}
            styles={styles}
            isMulti
            isClearable={true}
            isDisabled={disabled}
            menuIsOpen={readOnly || disabled ? false : undefined}
            closeMenuOnSelect={false}
            name={name}
            value={selected}
            placeholder={placeholder || t("Выберите...")}
            onChange={(data) => {
                setSelected(data);
                const val = data.map((o) => {
                    return o.value;
                });
                onChange(val);
            }}
            options={options}
        />
    );
}
